(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-builder"] && !Shopify.designMode) return;
  try {
    class BundleBuilderComponent extends HTMLElement {
    /** @type {{currencyCode:string,tiers:Array,flavors:Array,sellingPlans:Array}} */
    #db;
    /** @type {object} Block settings from Liquid */
    #settings;
    /** @type {Map<string, object>} flavor variant GID → flavor data */
    #variantMap;
    /** @type {Map<string, string>} productHandle → badge text */
    #badges = new Map();
    /** @type {Map<string, string>} productHandle → flavor description (custom.flavor metafield) */
    #flavorDescs = new Map();
    /** @type {{ bundleId: string, tier: number, selections: Map, sellingPlanId: string|null, adding: boolean }} */
    #state;
    /** @type {AbortController} */
    #controller;
    /** @type {Intl.NumberFormat} */
    #currencyFmt;
    /** @type {Intl.NumberFormat} */
    #currencyFmtInt;

    connectedCallback() {
      try {
        this.#readInlineData();
      } catch (err) {
        console.error('[bundle-builder] Init failed:', err);
        this.#renderError(err);
        return;
      }

      this.#buildVariantMap();

      const sizes = this.#tierSizes();
      this.#state = {
        bundleId: this.#generateId(),
        tier: sizes[Math.floor(sizes.length / 2)],
        selections: new Map(),
        sellingPlanId: null,
        adding: false,
      };

      this.#applyTheme();
      this.#restore();
      this.#reveal();
      this.#renderTiers();
      this.#renderFlavors();
      this.#renderSellingPlan();
      this.#updateGifts();
      this.#recompute();
      this.#bind();

      this.dispatchEvent(new CustomEvent('bundle:viewed', {
        bubbles: true,
        detail: { bundleId: this.#state.bundleId, tier: this.#state.tier },
      }));

      this.#fetchProductMetafields().then(() => {
        if (this.#badges.size || this.#flavorDescs.size) this.#renderFlavors();
      });
    }

    disconnectedCallback() {
      this.#controller?.abort();
    }

    /* ------------------------------------------------------------------ */
    /*  Setup                                                              */
    /* ------------------------------------------------------------------ */

    #readInlineData() {
      const settingsEl = this.querySelector('[data-bundle-settings]');
      if (!settingsEl) throw new Error('Settings script tag not found in DOM');
      this.#settings = JSON.parse(settingsEl.textContent);

      const dbEl = this.querySelector('[data-bundle-database]');
      if (!dbEl) throw new Error('Database script tag not found in DOM');
      const raw = JSON.parse(dbEl.textContent);

      if (typeof this.#settings.productBadges === 'string') {
        try { this.#settings.productBadges = JSON.parse(this.#settings.productBadges); }
        catch (_) { this.#settings.productBadges = {}; }
      }
      if (typeof this.#settings.productDescriptions === 'string') {
        try { this.#settings.productDescriptions = JSON.parse(this.#settings.productDescriptions); }
        catch (_) { this.#settings.productDescriptions = {}; }
      }

      const tiers = (raw.tiers || [])
        .map(entry => {
          const box = entry.metafield?.ClassicBoxV2 || {};
          const size = Number(box.size) || 0;
          if (!size) return null;
          return {
            variantId: String(entry.variantId),
            gid: box.platformId || `gid://shopify/ProductVariant/${entry.variantId}`,
            size,
            priceCents: Math.round(Number(box.price || 0) * 100),
            compareAtCents: Number(entry.compareAtCents) || 0,
            imageSrc: entry.variantImage || box.imageSrc || '',
            variantTitle: entry.variantTitle || '',
          };
        })
        .filter(Boolean);

      if (!tiers.length) {
        throw new Error('No tiers found — ensure product variants have a custom.skio_static_box metafield');
      }

      // Flavor list is frozen from tier 0 (merchant spec: same flavors across all tiers).
      const firstBox = raw.tiers[0]?.metafield?.ClassicBoxV2 || {};
      const flavors = (firstBox.selectableProductVariants || []).map(f => ({
        gid: f.platformId,
        variantId: String(f.platformId || '').split('/').pop(),
        productHandle: f.productSlug || '',
        productTitle: f.productTitle || '',
        productVariantTitle: f.productVariantTitle || '',
        productImageSrc: f.imageSrc || '',
        priceCents: Math.round(Number(f.price || 0) * 100),
        outOfStock: !!f.outOfStock,
      }));

      const sellingPlans = (raw.sellingPlanGroups || []).flatMap(group =>
        (group.sellingPlans || []).map(plan => ({
          id: String(plan.id),
          name: plan.name || '',
          groupName: group.name || '',
        }))
      );

      this.#db = {
        currencyCode: raw.currencyCode || 'USD',
        tiers,
        flavors,
        sellingPlans,
      };

      // Forced en-US / USD formatting so prices read "$49.99" everywhere,
      // independent of shop currency or browser locale.
      this.#currencyFmt = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
      });
      this.#currencyFmtInt = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    }

    #tierSizes() {
      return this.#db.tiers.map(t => t.size);
    }

    #tierBySize(size) {
      return this.#db.tiers.find(t => t.size === size);
    }

    #buildVariantMap() {
      this.#variantMap = new Map();
      for (const flavor of this.#db.flavors) {
        this.#variantMap.set(flavor.gid, flavor);
      }
    }

    async #fetchProductMetafields() {
      const flavors = this.#db.flavors;
      const parser = new DOMParser();
      await Promise.allSettled(
        flavors.map(async (flavor) => {
          if (!flavor.productHandle) return;
          const res = await fetch(`/products/${flavor.productHandle}?sections=bundle-badge-data,bundle-flavor-data`);
          if (!res.ok) return;
          const json = await res.json();
          const badgeHtml = json['bundle-badge-data'] || '';
          const descHtml = json['bundle-flavor-data'] || '';
          const badge = (parser.parseFromString(badgeHtml, 'text/html').body.textContent || '').trim();
          const desc = (parser.parseFromString(descHtml, 'text/html').body.textContent || '').trim();
          if (badge) this.#badges.set(flavor.productHandle, badge);
          if (desc) this.#flavorDescs.set(flavor.productHandle, desc);
        })
      );
    }

    #reveal() {
      const loader = this.querySelector('[data-bb-loading]');
      if (loader) loader.hidden = true;
      for (const el of this.querySelectorAll('[data-bb-step], .bb__tiers, [data-bb-progress], [data-bb-flavor-list], [data-bb-cta]')) {
        el.hidden = false;
      }
    }

    #renderError(err) {
      const loader = this.querySelector('[data-bb-loading]');
      if (loader) {
        loader.className = 'bb__error';
        const prefix = this.#settings?.i18n?.loadError || 'Bundle Builder could not load';
        loader.textContent = `${prefix}: ${err.message}`;
      }
    }

    #applyTheme() {
      // Intentional no-op: colors come from the block's color scheme, not the
      // DynamicBox JSON theme object. This keeps bundle styling consistent with
      // the rest of the theme's design system tokens.
    }

    #generateId() {
      if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return `box_${crypto.randomUUID()}`;
      }
      return `box_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    }

    /* ------------------------------------------------------------------ */
    /*  Persistence                                                        */
    /* ------------------------------------------------------------------ */

    #persistKey() {
      return `bundle:${this.dataset.bundleRoot}`;
    }

    #restore() {
      if (!this.#settings.persist) return;
      try {
        const raw = localStorage.getItem(this.#persistKey());
        if (!raw) return;
        const saved = JSON.parse(raw);
        if (Date.now() - saved.t > 24 * 3600 * 1000) {
          localStorage.removeItem(this.#persistKey());
          return;
        }
        if (this.#tierSizes().includes(saved.tier)) {
          this.#state.tier = saved.tier;
        }
        if (Array.isArray(saved.selections)) {
          for (const [id, qty] of saved.selections) {
            if (this.#variantMap.has(id) && qty > 0) {
              this.#state.selections.set(id, qty);
            }
          }
        }
        if (saved.sellingPlanId) {
          this.#state.sellingPlanId = saved.sellingPlanId;
        }
        const total = this.#totalSelected();
        if (total > this.#state.tier) {
          this.#trimOverflow(total - this.#state.tier);
        }
      } catch (_) { /* localStorage unavailable — continue in memory */ }
    }

    #persist() {
      if (!this.#settings.persist) return;
      try {
        localStorage.setItem(this.#persistKey(), JSON.stringify({
          t: Date.now(),
          tier: this.#state.tier,
          selections: [...this.#state.selections],
          sellingPlanId: this.#state.sellingPlanId,
        }));
      } catch (_) { /* quota exceeded — swallow */ }
    }

    /* ------------------------------------------------------------------ */
    /*  Pricing                                                            */
    /* ------------------------------------------------------------------ */

    #formatMoney(cents) {
      // Drop the decimal portion when it's exactly .00 (e.g. $50.00 → $50) but
      // keep it for fractional amounts (e.g. $49.99 stays as-is).
      const fmt = cents % 100 === 0 ? this.#currencyFmtInt : this.#currencyFmt;
      return fmt.format(cents / 100);
    }

    #computeTierPricing(size) {
      const tier = this.#tierBySize(size);
      if (!tier) return { compareCents: 0, finalCents: 0, perItemCents: 0 };

      const finalCents = Math.max(0, tier.priceCents);
      const sampleFlavorCents = this.#db.flavors[0]?.priceCents || 0;
      const retailCents = sampleFlavorCents * size;
      const compareCents = tier.compareAtCents > 0 ? tier.compareAtCents : retailCents;

      const portionsPerBox = Math.max(1, Number(this.#settings.tierPortionsPerBox) || 1);
      const totalPortions = size * portionsPerBox;

      return {
        compareCents,
        finalCents,
        perItemCents: totalPortions > 0 ? Math.round(finalCents / totalPortions) : 0,
      };
    }

    #computeSelectionPricing() {
      // Bundle is a single line item — the tier price is the total regardless of flavor mix.
      return this.#computeTierPricing(this.#state.tier);
    }

    /* ------------------------------------------------------------------ */
    /*  Rendering                                                          */
    /* ------------------------------------------------------------------ */

    /** Split tier badge on em/en dash or pipe for two-line promo (e.g. "BEST DEAL — SAVE 20%"). */
    #tierBadgeMarkup(badge) {
      if (!badge) return '';
      const raw = String(badge).trim();
      const parts = raw.split(/\s*[—–\-|]\s*/).map(s => s.trim()).filter(Boolean);
      if (parts.length >= 2) {
        return `<span class="bb__tier-badge"><span class="bb__tier-badge-primary">${this.#esc(parts[0])}</span><span class="bb__tier-badge-secondary">${this.#esc(parts.slice(1).join(' · '))}</span></span>`;
      }
      return `<span class="bb__tier-badge"><span class="bb__tier-badge-primary">${this.#esc(raw)}</span></span>`;
    }

    #renderTiers() {
      const grid = this.querySelector('[data-bb-tier-grid]');
      if (!grid) return;

      const tiers = this.#db.tiers;

      if (tiers.length === 1) {
        const fieldset = grid.closest('.bb__tiers');
        const stepHeader = fieldset?.previousElementSibling;
        fieldset?.setAttribute('hidden', '');
        if (stepHeader?.classList.contains('bb__step')) stepHeader.setAttribute('hidden', '');
        return;
      }

      grid.style.gridTemplateColumns = `repeat(${tiers.length}, 1fr)`;

      grid.innerHTML = tiers.map((tier, i) => {
        const { compareCents, finalCents, perItemCents } = this.#computeTierPricing(tier.size);
        const checked = tier.size === this.#state.tier;
        const badge = this.#settings.tierBadges[i] || '';
        const tierImage = this.#settings.tierImages?.[i] || tier.imageSrc;
        // Pipe "|" lets the variant title author force a line break in the tier card.
        const title = tier.variantTitle || '';
        const titleHtml = title.split('|').map(part => this.#esc(part.trim())).join('<br>');
        const titleAlt = title.replaceAll('|', ' ');
        const tierSuffix = String(this.#settings.tierPerUnitSuffix ?? 'bowl').trim() || 'bowl';
        const perLabel = `${this.#formatMoney(perItemCents)}/${this.#esc(tierSuffix)}`;
        const compareHtml = compareCents > finalCents
          ? `<span class="bb__tier-price-compare"><s>${this.#formatMoney(compareCents)}</s></span>`
          : '';
        const tierImageHtml = tierImage
          ? `<span class="bb__tier-media"><img class="bb__tier-img" src="${this.#safeUrlAttr(tierImage)}" alt="${this.#esc(titleAlt)}" loading="lazy" width="240" height="160" decoding="async" /><span class="bb__tier-qty" aria-hidden="true">x${tier.size}</span></span>`
          : '';

        return `
          <label class="bb__tier" data-tier="${tier.size}">
            ${this.#tierBadgeMarkup(badge)}
            <span class="bb__tier-stack">
              <span class="bb__tier-title">${titleHtml}</span>
              <span class="bb__tier-price-block">
                <span class="bb__tier-price-current">${this.#formatMoney(finalCents)}</span>
                ${compareHtml}
              </span>
              ${tierImageHtml}
            </span>
            <span class="bb__tier-per">${perLabel}</span>
            <input
              type="radio"
              name="bb-tier-${this.dataset.bundleRoot}"
              value="${tier.size}"
              ${checked ? 'checked' : ''}
              class="bb__sr-only"
            />
          </label>`;
      }).join('');
    }

    #renderFlavors() {
      const list = this.querySelector('[data-bb-flavor-list]');
      if (!list) return;

      const flavors = this.#db.flavors;
      const full = this.#totalSelected() >= this.#state.tier;

      list.innerHTML = flavors.map(flavor => {
        const qty = this.#state.selections.get(flavor.gid) || 0;
        const productId = flavor.variantId;
        const badge = this.#badges.get(flavor.productHandle) || this.#settings.productBadges?.[productId] || '';
        const desc = this.#flavorDescs.get(flavor.productHandle) || this.#settings.productDescriptions?.[productId] || '';
        const soldOut = flavor.outOfStock;

        let actionHtml;
        if (soldOut) {
          actionHtml = `<span class="bb__sold-out" aria-disabled="true">${this.#esc(this.#i18n('soldOut', 'Sold out'))}</span>`;
        } else if (qty > 0) {
          actionHtml = `
            <div class="bb__qty">
              <button type="button" data-bb-dec aria-label="Remove one ${this.#esc(flavor.productTitle)}">−</button>
              <span class="bb__qty-count">${qty}</span>
              <button type="button" data-bb-inc aria-label="Add one more ${this.#esc(flavor.productTitle)}" ${full ? 'disabled' : ''}>+</button>
            </div>`;
        } else {
          actionHtml = `<button type="button" class="bb__add" data-bb-add ${full ? 'disabled' : ''} aria-label="Add ${this.#esc(flavor.productTitle)} to bundle">${this.#esc(this.#i18n('add', 'Add'))}</button>`;
        }

        return `
          <li class="bb__flavor"
            data-variant="${flavor.gid}"
            data-selected="${qty > 0}"
            data-sold-out="${soldOut}"
          >
            <div class="bb__flavor-media">
              <img
                class="bb__flavor-img"
                src="${flavor.productImageSrc || ''}"
                alt="${this.#esc(flavor.productTitle)}"
                loading="lazy"
                width="56"
                height="56"
              />
            </div>
            <div class="bb__flavor-info">
              <div class="bb__flavor-head">
                <span class="bb__flavor-name">${this.#esc(flavor.productTitle.toUpperCase())}</span>
                ${badge ? `<span class="bb__pill">${this.#esc(badge)}</span>` : ''}
              </div>
              ${desc ? `<p class="bb__flavor-desc">${this.#esc(desc)}</p>` : ''}
            </div>
            <div class="bb__flavor-actions">
              ${actionHtml}
            </div>
          </li>`;
      }).join('');
    }

    #firstSellingPlanId() {
      return this.#db.sellingPlans[0]?.id || null;
    }

    #renderSellingPlan() {
      const firstId = this.#firstSellingPlanId();
      if (firstId) this.#state.sellingPlanId = firstId;
    }

    /** Build the ATC property key for a flavor — omits the "Default Title" variant suffix. */
    #humanPropKey(flavor) {
      const vt = (flavor.productVariantTitle || '').trim();
      return vt && vt !== 'Default Title' ? `${flavor.productTitle} - ${vt}` : flavor.productTitle;
    }

    #updateGifts() {
      for (const gift of this.querySelectorAll('[data-bb-gift]')) {
        const unlockTier = parseInt(gift.dataset.unlockTier, 10) || Infinity;
        gift.dataset.locked = this.#state.tier < unlockTier ? 'true' : 'false';
      }
      this.#updateGiftsProgress();
    }

    /** 0–1 progress between gift unlock tiers (single bar fill). */
    #giftProgressFraction(tier, tiers) {
      const u0 = tiers[0];
      const u1 = tiers[1];
      const u2 = tiers[2];
      const t = tier;
      if (!Number.isFinite(u0)) return 0;
      if (t < u0) return 0;
      if (!Number.isFinite(u1)) return 1;
      if (t < u1) {
        const d = u1 - u0;
        return d > 0 ? 0.5 * (t - u0) / d : 0.5;
      }
      if (!Number.isFinite(u2)) return 0.5;
      if (t < u2) {
        const d = u2 - u1;
        return d > 0 ? 0.5 + 0.5 * (t - u1) / d : 1;
      }
      return 1;
    }

    /** Gifts stepped bar: one track fill + node highlights vs bundle tier. */
    #updateGiftsProgress() {
      const root = this.querySelector('[data-bb-gifts-progress]');
      if (!root) return;

      const gifts = this.#settings.gifts || [];
      const tiers = [0, 1, 2].map(i => {
        const u = gifts[i]?.unlockTier;
        if (u == null || u === '') return Infinity;
        const n = Number(u);
        return Number.isFinite(n) ? n : Infinity;
      });

      const tier = this.#state.tier;
      const p = this.#giftProgressFraction(tier, tiers);
      root.style.setProperty('--bb-gifts-fill', String(p));

      for (let i = 0; i < 3; i++) {
        const node = root.querySelector(`[data-bb-gift-node="${i}"]`);
        if (node) node.dataset.active = tier >= tiers[i] ? 'true' : 'false';
      }
    }

    #recompute() {
      const sel = this.#totalSelected();
      const tier = this.#state.tier;

      const fill = this.querySelector('[data-bb-progress-fill]');
      const currentEl = this.querySelector('[data-bb-progress-current]');
      const totalEl = this.querySelector('[data-bb-progress-total]');
      const progress = this.querySelector('[data-bb-progress]');
      const cta = this.querySelector('[data-bb-cta]');
      const price = this.querySelector('[data-bb-cta-price]');
      const compare = this.querySelector('[data-bb-cta-compare]');

      if (fill) fill.style.width = `${Math.min((sel / tier) * 100, 100)}%`;
      if (currentEl) currentEl.textContent = String(sel);
      if (totalEl) totalEl.textContent = String(tier);
      if (progress) {
        progress.setAttribute('aria-valuemax', String(tier));
        progress.setAttribute('aria-valuenow', String(sel));
      }
      const ctaMain = this.querySelector('[data-bb-cta-main]');
      const ctaIncomplete = this.querySelector('[data-bb-cta-incomplete]');

      if (cta) {
        // Button stays enabled when incomplete — clicking scrolls to the flavor picker.
        cta.disabled = this.#state.adding;

        if (sel < tier) {
          cta.setAttribute('data-bb-cta-state', 'incomplete');
          const need = tier - sel;
          if (ctaIncomplete) {
            const one = this.#i18n('chooseOneMore', 'Select 1 more flavor');
            const many = this.#i18n('chooseMore', 'Select {count} more flavors');
            ctaIncomplete.textContent =
              need === 1 ? one : many.replace('{count}', String(need));
            ctaIncomplete.hidden = false;
          }
          if (ctaMain) ctaMain.hidden = true;
        } else {
          if (this.#state.adding) {
            cta.setAttribute('data-bb-cta-state', 'adding');
          } else {
            cta.removeAttribute('data-bb-cta-state');
          }
          if (ctaIncomplete) ctaIncomplete.hidden = true;
          if (ctaMain) ctaMain.hidden = false;
        }
      }

      const pricing = this.#computeTierPricing(tier);

      if (sel < tier) {
        if (price) price.textContent = '';
        if (compare) compare.textContent = '';
      } else {
        if (price) price.textContent = ` — ${this.#formatMoney(pricing.finalCents)}`;
        if (compare) {
          compare.textContent = pricing.compareCents > pricing.finalCents
            ? this.#formatMoney(pricing.compareCents)
            : '';
        }
      }

      this.#persist();
    }

    /* ------------------------------------------------------------------ */
    /*  Event handling                                                     */
    /* ------------------------------------------------------------------ */

    #bind() {
      this.#controller = new AbortController();
      const { signal } = this.#controller;

      this.addEventListener('change', (e) => {
        const target = /** @type {HTMLInputElement} */ (e.target);

        if (target.name?.startsWith('bb-tier-')) {
          this.#setTier(parseInt(target.value));
          return;
        }

        if (target.name?.startsWith('bb-sp-')) {
          this.#state.sellingPlanId = target.value || null;
          this.#persist();
        }
      }, { signal });

      this.addEventListener('click', (e) => {
        const target = /** @type {HTMLElement} */ (e.target);

        const flavor = target.closest('.bb__flavor');
        if (flavor) {
          const id = /** @type {string} */ (/** @type {HTMLElement} */ (flavor).dataset.variant);
          if (target.closest('[data-bb-add]') || target.closest('[data-bb-inc]')) {
            this.#changeQty(id, 1);
          } else if (target.closest('[data-bb-dec]')) {
            this.#changeQty(id, -1);
          }
          return;
        }

        if (target.closest('[data-bb-cta]')) {
          if (this.#state.adding) return;
          if (this.#totalSelected() < this.#state.tier) {
            const step = this.querySelector('[data-bb-step="2"]')
              || this.querySelector('[data-bb-flavor-list]');
            step?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
          }
          this.#submit();
        }
      }, { signal });

      this.addEventListener('keydown', (e) => {
        if (e.target instanceof HTMLElement && e.target.closest('.bb__tier') && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          /** @type {HTMLInputElement|null} */
          const input = e.target.closest('.bb__tier')?.querySelector('input[type="radio"]');
          if (input) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }, { signal });
    }

    /* ------------------------------------------------------------------ */
    /*  State mutations                                                    */
    /* ------------------------------------------------------------------ */

    #setTier(size) {
      if (!this.#tierSizes().includes(size)) return;
      this.#state.tier = size;

      const total = this.#totalSelected();
      if (total > size) this.#trimOverflow(total - size);

      this.#renderFlavors();
      this.#updateGifts();
      this.#recompute();

      this.dispatchEvent(new CustomEvent('bundle:tier-selected', {
        bubbles: true,
        detail: { bundleId: this.#state.bundleId, tier: size },
      }));
    }

    #trimOverflow(excess) {
      let remaining = excess;
      const entries = [...this.#state.selections.entries()].reverse();
      for (const [id, qty] of entries) {
        if (remaining <= 0) break;
        const take = Math.min(qty, remaining);
        const newQty = qty - take;
        if (newQty === 0) {
          this.#state.selections.delete(id);
        } else {
          this.#state.selections.set(id, newQty);
        }
        remaining -= take;
      }
    }

    #changeQty(variantId, delta) {
      const current = this.#state.selections.get(variantId) || 0;
      const next = current + delta;

      if (next < 0) return;
      if (delta > 0 && this.#totalSelected() >= this.#state.tier) return;

      const variant = this.#variantMap.get(variantId);
      if (delta > 0 && variant?.available === false && variant.inventoryPolicy !== 'continue') return;

      if (next === 0) {
        this.#state.selections.delete(variantId);
      } else {
        this.#state.selections.set(variantId, next);
      }

      this.#renderFlavors();
      this.#recompute();

      if (delta > 0) {
        this.dispatchEvent(new CustomEvent('bundle:flavor-added', {
          bubbles: true,
          detail: { bundleId: this.#state.bundleId, variantId, qty: next },
        }));
      }

      if (this.#totalSelected() === this.#state.tier) {
        this.dispatchEvent(new CustomEvent('bundle:completed', {
          bubbles: true,
          detail: { bundleId: this.#state.bundleId, tier: this.#state.tier },
        }));
      }
    }

    #totalSelected() {
      let total = 0;
      for (const qty of this.#state.selections.values()) total += qty;
      return total;
    }

    /* ------------------------------------------------------------------ */
    /*  Cart submission                                                    */
    /* ------------------------------------------------------------------ */

    async #submit() {
      if (this.#totalSelected() !== this.#state.tier || this.#state.adding) return;

      this.#state.adding = true;
      this.#recompute();

      const tier = this.#tierBySize(this.#state.tier);
      if (!tier) {
        this.#state.adding = false;
        this.#recompute();
        return;
      }

      const item = {
        id: parseInt(tier.variantId, 10),
        quantity: 1,
        properties: { _isClassicBoxV2: true },
      };

      const sellingPlanId = this.#state.sellingPlanId || this.#firstSellingPlanId();
      if (sellingPlanId) {
        item.selling_plan = parseInt(sellingPlanId, 10);
      }

      const contentsParts = [];
      for (const [gid, qty] of this.#state.selections) {
        const flavor = this.#variantMap.get(gid);
        if (!flavor) continue;
        contentsParts.push(`${qty}x ${this.#humanPropKey(flavor)}`);
        item.properties[`_pv${flavor.gid}`] = String(qty);
      }
      if (contentsParts.length) {
        item.properties['Contents'] = contentsParts.join(', ');
      }

      const items = [item];

      // Gifts are handled by the auto-gift app installed on the store; the
      // bundle-builder's role is purely visual (progress bar + unlock tiers).

      // Use the localized cart route when available so multi-market storefronts
      // hit the correct endpoint and Shopify's server-side analytics
      // (`product_added_to_cart`) are attributed to the right market/locale.
      const routes = (window.Theme && window.Theme.routes) || {};
      const cartAddUrl = routes.cart_add_url || '/cart/add.js';
      const cartUrl = routes.cart_url || '/cart';

      // Request the cart-drawer section so it can re-render in a single
      // round-trip (matches product-form.js convention for this theme).
      const sectionIds = new Set();
      const cartDrawerEl = document.querySelector('cart-drawer');
      if (cartDrawerEl?.dataset.sectionId) sectionIds.add(cartDrawerEl.dataset.sectionId);

      const totalQuantity = items.reduce((sum, item) => sum + (item.quantity || 0), 0);

      try {
        const body = { items, sections_url: window.location.pathname };
        if (sectionIds.size) body.sections = Array.from(sectionIds).join(',');

        const res = await fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(body),
        });

        const response = await res.json().catch(() => null);

        // Shopify returns 422 with a `status`/`message` payload on validation
        // errors (sold out, max qty, invalid variant, etc.).
        if (!res.ok || (response && response.status)) {
          const message = (response && response.message) || 'Cart update failed';

          // Theme convention (product-form.js): surface cart errors as a toast.
          document.dispatchEvent(new CustomEvent('toast:open', {
            bubbles: true,
            detail: { type: 'error', message },
          }));

          throw new Error(message);
        }

        // Fetch the authoritative cart so listeners get accurate item_count,
        // currency, and totals — same pattern as product-form.js.
        let cart = null;
        try {
          const cartRes = await fetch(`${cartUrl}.js`);
          if (cartRes.ok) cart = await cartRes.json();
        } catch (_) { /* noop */ }

        // cart-icon stores the absolute total, so derive the new count from
        // its current value plus what we just added (matches product-form.js).
        const cartIcon = document.querySelector('cart-icon');
        const currentItemCount = cartIcon?.getCurrentItemCount?.() ?? 0;
        const newItemCount = (Number.isNaN(currentItemCount) ? 0 : currentItemCount) + totalQuantity;

        // Theme's CartUpdatedEvent — cart-drawer re-renders its section,
        // cart-icon updates the bubble (and auto-opens the drawer when
        // its data-add-to-cart-behavior is set to 'open_cart').
        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            resource: cart || {},
            data: {
              source: 'bundle-builder',
              itemCount: newItemCount,
              sections: response && response.sections,
            },
          },
        }));

        // Keep the legacy business event for downstream integrations
        // (e.g. GTM dataLayer, A/B tests) that already listen for it.
        this.dispatchEvent(new CustomEvent('bundle:added-to-cart', {
          bubbles: true,
          detail: {
            bundleId: this.#state.bundleId,
            tier: this.#state.tier,
            itemCount: items.length,
          },
        }));

        try { localStorage.removeItem(this.#persistKey()); } catch (_) { /* noop */ }

        this.#state.selections.clear();
        this.#state.bundleId = this.#generateId();

        // Respect the merchant-configured post-add behavior.
        const behavior = this.#settings.postAddBehavior || 'drawer';
        if (behavior === 'checkout') {
          window.location.href = '/checkout';
          return;
        }
        if (behavior === 'redirect') {
          window.location.href = cartUrl;
          return;
        }
        if (behavior === 'drawer') {
          // cart-drawer listens for ThemeEvents.cartOpen ('cart:open').
          document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
        }
        return;
      } catch (err) {
        console.error('[bundle-builder] Cart add failed:', err);
        this.#showToast(this.#i18n('cartError', 'Could not add to cart. Please try again.'));
      } finally {
        this.#state.adding = false;
        this.#renderFlavors();
        this.#recompute();
      }
    }

    /* ------------------------------------------------------------------ */
    /*  Utilities                                                          */
    /* ------------------------------------------------------------------ */

    #showToast(message) {
      const existing = this.querySelector('.bb__toast');
      if (existing) existing.remove();

      const toast = document.createElement('div');
      toast.className = 'bb__toast';
      toast.textContent = message;
      toast.setAttribute('role', 'alert');
      this.appendChild(toast);
      setTimeout(() => toast.remove(), 4000);
    }

    #esc(str) {
      const el = document.createElement('span');
      el.textContent = str;
      return el.innerHTML;
    }

    /** Escape a URL for use in HTML double-quoted attributes. */
    #safeUrlAttr(url) {
      return String(url)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;');
    }

    #i18n(key, fallback) {
      return this.#settings?.i18n?.[key] || fallback;
    }
  }

  if (!customElements.get('bundle-builder')) {
    customElements.define('bundle-builder', BundleBuilderComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
